(function() {
  function initPdpShippingCost(priceCostArray, baseWeight) {
    try {
      const weightElement = document.querySelector('.product__inventory-cost');
      if (!weightElement) return;
      
      if (!Array.isArray(priceCostArray) || priceCostArray.length === 0) return;
      
      const lastItem = priceCostArray[priceCostArray.length - 1];
      
      function calculateShippingCost(quantity) {
        const totalWeight = baseWeight * quantity;
        let foundPrice = null;
        
        // Buscar el rango de precio correcto
        for (let i = 0; i < priceCostArray.length; i++) {
          const item = priceCostArray[i];
          if (totalWeight >= item.min_weight && totalWeight <= item.max_weight) {
            foundPrice = item.price;
            break;
          }
        }
        
        // Si el peso excede el máximo, usar el último precio
        if (foundPrice === null && totalWeight > lastItem.max_weight) {
          foundPrice = lastItem.price;
        }
        
        // Mostrar el precio si se encontró
        if (foundPrice !== null) {
          weightElement.textContent = "+" + foundPrice.toFixed(2).replace('.', ',') + " € de Gastos de Envío";
          weightElement.dataset.price = foundPrice;
        }
      }
      
      // Función para obtener la cantidad del bundle seleccionado
      function getBundleQuantity() {
        const checkedBundle = document.querySelector('.bndlr-radio-container input[type="radio"]:checked, .bndlr-radio-container[data-bundler-break-active="true"]');
        if (checkedBundle) {
          // Intentar obtener la cantidad del bundle
          const quantityAttr = checkedBundle.getAttribute('value') || checkedBundle.querySelector('input[type="radio"]:checked')?.value;
          if (quantityAttr) {
            return parseInt(quantityAttr) || 1;
          }
          // Buscar en el nombre del bundle (ej: "bundle_quantity")
          const bundleInput = document.querySelector('.bndlr-radio-container[data-bundler-break-active="true"] input[name="bundle_quantity"]:checked');
          if (bundleInput) {
            return parseInt(bundleInput.value) || 1;
          }
        }
        return null; // null indica que no hay bundle activo
      }
      
      // Función para obtener la cantidad del quantity input normal
      function getQuantityInputValue() {
        const quantityInput = document.querySelector('quantity-input .quantity__input, quantity-selector .quantity__input, input[name="quantity"]');
        if (quantityInput) {
          return parseInt(quantityInput.value) || 1;
        }
        return 1;
      }
      
      // Función para obtener la cantidad total (bundle o normal)
      function getCurrentQuantity() {
        const bundleQty = getBundleQuantity();
        if (bundleQty !== null) {
          return bundleQty;
        }
        return getQuantityInputValue();
      }
      
      // Calcular inicialmente
      calculateShippingCost(getCurrentQuantity());
      
      // Escuchar cambios en los bundles
      document.addEventListener('change', function(e) {
        if (e.target.closest('.bndlr-radio-container') || e.target.closest('.bndlr-quantity-break') || e.target.name === 'bundle_quantity') {
          setTimeout(function() {
            calculateShippingCost(getCurrentQuantity());
          }, 100);
        }
        
        // Escuchar cambios en el quantity input normal
        if (e.target.classList.contains('quantity__input') || e.target.name === 'quantity') {
          setTimeout(function() {
            calculateShippingCost(getCurrentQuantity());
          }, 50);
        }
      });
      
      // Escuchar clicks en los contenedores de bundle
      document.addEventListener('click', function(e) {
        if (e.target.closest('.bndlr-radio-container') || e.target.closest('.bndlr-quantity-break')) {
          setTimeout(function() {
            calculateShippingCost(getCurrentQuantity());
          }, 100);
        }
        
        // Escuchar clicks en los botones de cantidad (+/-)
        if (e.target.closest('.quantity__button') || e.target.closest('quantity-input button') || e.target.closest('quantity-selector button')) {
          setTimeout(function() {
            calculateShippingCost(getCurrentQuantity());
          }, 50);
        }
      });
      
      // Escuchar eventos de input para capturar cambios directos en el campo
      document.addEventListener('input', function(e) {
        if (e.target.classList.contains('quantity__input') || e.target.name === 'quantity') {
          setTimeout(function() {
            calculateShippingCost(getCurrentQuantity());
          }, 50);
        }
      });
      
      // MutationObserver para detectar cambios en el atributo data-bundler-break-active
      const bundleContainers = document.querySelectorAll('.bndlr-radio-container');
      if (bundleContainers.length > 0) {
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-bundler-break-active') {
              setTimeout(function() {
                calculateShippingCost(getCurrentQuantity());
              }, 100);
            }
          });
        });
        
        bundleContainers.forEach(function(container) {
          observer.observe(container, { attributes: true });
        });
      }
      
      // MutationObserver para detectar cambios en el valor del quantity input
      const quantityInputs = document.querySelectorAll('.quantity__input, input[name="quantity"]');
      if (quantityInputs.length > 0) {
        const valueObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && (mutation.attributeName === 'value' || mutation.attributeName === 'data-cart-quantity')) {
              setTimeout(function() {
                calculateShippingCost(getCurrentQuantity());
              }, 50);
            }
          });
        });
        
        quantityInputs.forEach(function(input) {
          valueObserver.observe(input, { attributes: true, attributeFilter: ['value', 'data-cart-quantity'] });
        });
      }
      
    } catch (error) {
      console.error('Error calculating shipping cost:', error);
    }
  }
  
  // Exponer la función globalmente
  window.initPdpShippingCost = initPdpShippingCost;
})();
